export default __webpack_public_path__ + "static/media/alert-icon-white.217a81ed.svg";